import base from './base';

export default {
  ...base,
  common: {
    ...base.common,
    en: 'EN',
    es: 'ES',
    summary: 'Company Summary'
  },
  inspections: {
    ...base.inspections,
    addNewForm: "Add a new form",
    addNewVehicleForm: "Add a new vehicle form",
    addNewTrailerForm: "Add a new trailer form",
    formName: "Form Name",
    vehiclesCount: "Vehicles Count",
    addForm: "Add Form",
    editForm: "Edit Form",
    addNewArea:"Add New Area",
    areasAndParts: "Areas and Parts",
    addNewParts: "Add new parts",
    defects: "Defects",
    addNewDefects: "Add new Defects",
    areaName: "Area Name",
    areaType: "Area Type"
  },
  footer: {
    address: {
      one: 'Business Address',
      two: 'Telephone / Fax',
      three: 'Online',
      onedetails: '2828 North Central Ave., 7th Floor Phoenix, AZ 85004',
      twodetails: '757-941-7806',
      threedetails: 'eldsupport@truckerpath.com'
    },
    patent: 'Patent pending',
    copyright: '2020 Trucker Path All Rights Reserved',
    PrivacyLegal: 'Privacy Policy'
  }
};
